import { ReactElement } from "react";
import styles from "./ReorderableList.module.less";

export const Separator = (): ReactElement => {
	return (
		<hr className={styles.separator} />
	);
};

Separator.displayName = "ReorderableList.Separator";
